// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/stock-img/about_us_bg_img.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/mask-img/about-us-bg-mask.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/assets/svg-img/list-bullet-img.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-us-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.about-us-section .about-us-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.about-us-section .about-us-wrap .about-us-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.about-us-section .about-us-wrap .about-us-box .about-us-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  position: relative;
}
.about-us-section .about-us-wrap .about-us-box .about-us-container .text-box {
  width: calc(100% - 2rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), linear-gradient(175deg, var(--mediumOrchid-1000) 4%, var(--primaryMain-1000) 96%);
  background-repeat: no-repeat;
  background-size: 80.5rem, cover;
  background-position: bottom right, center center;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  mask-repeat: no-repeat;
  mask-size: 100% 100%;
  aspect-ratio: 382/125;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 5rem 2rem 3rem;
  margin-left: auto;
}
.about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner {
  width: 100%;
  max-width: 58rem;
}
.about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box {
  --list-text-grid-number: 2;
  --list-text-grid-row-gap: 2rem;
  --list-text-grid-column-gap: 2rem;
  list-style-type: none;
  display: grid;
  grid-template-columns: repeat(var(--list-text-grid-number), 1fr);
  row-gap: var(--list-text-grid-row-gap);
  column-gap: var(--list-text-grid-column-gap);
}
.about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box .list-text {
  --list-text-font-size: 1.5rem;
  --list-text-margin-left: 2rem;
  color: var(--white-1000);
  font-size: var(--list-text-font-size);
  font-weight: 700;
  line-height: 1.4;
  margin-left: var(--list-text-margin-left);
  position: relative;
}
.about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box .list-text::before {
  content: "";
  width: var(--list-text-font-size);
  height: var(--list-text-font-size);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  display: block;
  position: absolute;
  top: 0.25rem;
  left: calc(var(--list-text-margin-left) - var(--list-text-margin-left) - var(--list-text-margin-left));
}
.about-us-section .about-us-wrap .about-us-box .about-us-container .img-box {
  width: 100%;
  max-width: 32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: absolute;
  top: 2rem;
  left: 0;
}
.about-us-section .about-us-wrap .about-us-box .about-us-container .img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
@media screen and (max-width: 991.98px) {
  .about-us-section {
    padding: 2.5rem 0;
    margin: 0 auto;
  }
  .about-us-section .about-us-wrap .about-us-box .para-text {
    font-size: 1rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box {
    width: 100%;
    border-radius: 1.5rem;
    mask-image: none;
    mask-repeat: unset;
    mask-size: unset;
    aspect-ratio: unset;
    padding: 1.5rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner {
    max-width: 58rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box {
    --list-text-grid-number: 2;
    --list-text-grid-row-gap: 0.875rem;
    --list-text-grid-column-gap: 1rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box .list-text {
    --list-text-font-size: 1rem;
    --list-text-margin-left: 1.25rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .img-box {
    max-width: 12rem;
    display: none;
  }
}
@media screen and (max-width: 767.98px) {
  .about-us-section {
    padding: 2rem 0;
    margin: 0 auto;
  }
  .about-us-section .about-us-wrap .about-us-box .para-text {
    font-size: 0.875rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box {
    border-radius: 1rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner {
    max-width: unset;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box {
    --list-text-grid-number: 2;
    --list-text-grid-row-gap: 0.5rem;
    --list-text-grid-column-gap: 0.75rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box .list-text {
    --list-text-font-size: 0.875rem;
    --list-text-margin-left: 1.25rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .img-box {
    max-width: 9rem;
  }
}
@media screen and (max-width: 639.98px) {
  .about-us-section {
    padding: 2rem 0;
    margin: 0 auto;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container {
    flex-direction: column;
    gap: 1rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .img-box {
    max-width: 9rem;
    display: none;
  }
}
@media screen and (max-width: 474.98px) {
  .about-us-section {
    padding: 2rem 0;
    margin: 0 auto;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container {
    flex-direction: column;
    gap: 1rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box {
    --list-text-grid-number: 1;
    --list-text-grid-row-gap: 0.5rem;
    --list-text-grid-column-gap: 0.75rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .text-box .text-box-inner .list-text-box .list-text {
    --list-text-font-size: 0.875rem;
    --list-text-margin-left: 1.25rem;
  }
  .about-us-section .about-us-wrap .about-us-box .about-us-container .img-box {
    max-width: 9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AboutUsSection/AboutUsStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAGM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AADR;AAGQ;EACE,wBAAA;EACA,sIAAA;EACA,4BAAA;EACA,+BAAA;EACA,gDAAA;EACA,mDAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;AADV;AAGU;EACE,WAAA;EACA,gBAAA;AADZ;AAGY;EACE,0BAAA;EACA,8BAAA;EACA,iCAAA;EACA,qBAAA;EACA,aAAA;EACA,gEAAA;EACA,sCAAA;EACA,4CAAA;AADd;AAGc;EACE,6BAAA;EACA,6BAAA;EACA,wBAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;EACA,kBAAA;AADhB;AAGgB;EACE,WAAA;EACA,iCAAA;EACA,kCAAA;EACA,yDAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,sGAAA;AADlB;AAQQ;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;AANV;AAQU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AANZ;AAaE;EAzGF;IA0GI,iBAAA;IACA,cAAA;EAVF;EAcM;IACE,eAAA;EAZR;EAgBQ;IACE,WAAA;IACA,qBAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,eAAA;EAdV;EAgBU;IACE,gBAAA;EAdZ;EAgBY;IACE,0BAAA;IACA,kCAAA;IACA,iCAAA;EAdd;EAgBc;IACE,2BAAA;IACA,gCAAA;EAdhB;EAoBQ;IACE,gBAAA;IACA,aAAA;EAlBV;AACF;AAwBE;EAtJF;IAuJI,eAAA;IACA,cAAA;EArBF;EAyBM;IACE,mBAAA;EAvBR;EA2BQ;IACE,mBAAA;EAzBV;EA2BU;IACE,gBAAA;EAzBZ;EA2BY;IACE,0BAAA;IACA,gCAAA;IACA,oCAAA;EAzBd;EA2Bc;IACE,+BAAA;IACA,gCAAA;EAzBhB;EA+BQ;IACE,eAAA;EA7BV;AACF;AAmCE;EA5LF;IA6LI,eAAA;IACA,cAAA;EAhCF;EAoCM;IACE,sBAAA;IACA,SAAA;EAlCR;EAoCQ;IACE,eAAA;IACA,aAAA;EAlCV;AACF;AAwCE;EA/MF;IAgNI,eAAA;IACA,cAAA;EArCF;EAyCM;IACE,sBAAA;IACA,SAAA;EAvCR;EA2CY;IACE,0BAAA;IACA,gCAAA;IACA,oCAAA;EAzCd;EA2Cc;IACE,+BAAA;IACA,gCAAA;EAzChB;EA+CQ;IACE,eAAA;EA7CV;AACF","sourcesContent":[".about-us-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .about-us-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .about-us-box {\n      .para-text {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n\n      .about-us-container {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 0.5rem;\n        margin-top: 1rem;\n        position: relative;\n\n        .text-box {\n          width: calc(100% - 2rem);\n          background: url(\"../../../public/assets/stock-img/about_us_bg_img.webp\"), linear-gradient(175deg, var(--mediumOrchid-1000) 4%, var(--primaryMain-1000) 96%);\n          background-repeat: no-repeat;\n          background-size: 80.5rem, cover;\n          background-position: bottom right, center center;\n          mask-image: url(\"../../../public/assets/mask-img/about-us-bg-mask.svg\");\n          mask-repeat: no-repeat;\n          mask-size: 100% 100%;\n          aspect-ratio: 382/125;\n          display: flex;\n          justify-content: flex-end;\n          align-items: flex-end;\n          padding: 5rem 2rem 3rem;\n          margin-left: auto;\n\n          .text-box-inner {\n            width: 100%;\n            max-width: 58rem;\n            \n            .list-text-box {\n              --list-text-grid-number: 2;\n              --list-text-grid-row-gap: 2rem;\n              --list-text-grid-column-gap: 2rem;\n              list-style-type: none;\n              display: grid;\n              grid-template-columns: repeat(var(--list-text-grid-number), 1fr);\n              row-gap: var(--list-text-grid-row-gap);\n              column-gap: var(--list-text-grid-column-gap);\n              \n              .list-text {\n                --list-text-font-size: 1.5rem;\n                --list-text-margin-left: 2rem;\n                color: var(--white-1000);\n                font-size: var(--list-text-font-size);\n                font-weight: 700;\n                line-height: 1.4;\n                margin-left: var(--list-text-margin-left);\n                position: relative;\n\n                &::before {\n                  content: \"\";\n                  width: var(--list-text-font-size);\n                  height: var(--list-text-font-size);\n                  background-image: url(\"../../../public/assets/svg-img/list-bullet-img.svg\");\n                  background-repeat: no-repeat;\n                  background-size: 100%;\n                  background-position: center;\n                  display: block;\n                  position: absolute;\n                  top: 0.25rem;\n                  left: calc(var(--list-text-margin-left) - var(--list-text-margin-left) - var(--list-text-margin-left));\n                }\n              }\n            }\n          }\n        }\n\n        .img-box {\n          width: 100%;\n          max-width: 32rem;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          z-index: 1;\n          position: absolute;\n          top: 2rem;\n          left: 0;\n\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            object-position: center;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n    margin: 0 auto;\n\n    .about-us-wrap {\n      .about-us-box {\n        .para-text {\n          font-size: 1rem;\n        }\n  \n        .about-us-container {  \n          .text-box {     \n            width: 100%;  \n            border-radius: 1.5rem; \n            mask-image: none;\n            mask-repeat: unset;\n            mask-size: unset;\n            aspect-ratio: unset;  \n            padding: 1.5rem;\n\n            .text-box-inner {\n              max-width: 58rem;\n \n              .list-text-box {\n                --list-text-grid-number: 2;\n                --list-text-grid-row-gap: 0.875rem;\n                --list-text-grid-column-gap: 1rem;\n                \n                .list-text {\n                  --list-text-font-size: 1rem;\n                  --list-text-margin-left: 1.25rem;\n                }\n              }\n            }\n          }\n  \n          .img-box {\n            max-width: 12rem;\n            display: none;\n          }\n        }\n      }\n    }  \n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n    margin: 0 auto;\n\n    .about-us-wrap {\n      .about-us-box {\n        .para-text {\n          font-size: 0.875rem;\n        }\n  \n        .about-us-container {  \n          .text-box {\n            border-radius: 1rem;\n\n            .text-box-inner {\n              max-width: unset;\n\n              .list-text-box {\n                --list-text-grid-number: 2;\n                --list-text-grid-row-gap: 0.5rem;\n                --list-text-grid-column-gap: 0.75rem;\n                \n                .list-text {\n                  --list-text-font-size: 0.875rem;\n                  --list-text-margin-left: 1.25rem;\n                }\n              }\n            }\n          }\n  \n          .img-box {\n            max-width: 9rem;\n          }\n        }\n      }\n    }  \n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n    margin: 0 auto;\n\n    .about-us-wrap {\n      .about-us-box {  \n        .about-us-container {\n          flex-direction: column;\n          gap: 1rem;\n  \n          .img-box {\n            max-width: 9rem;\n            display: none;\n          }\n        }\n      }\n    }  \n  }\n\n  @media screen and (max-width: 474.98px) {\n    padding: 2rem 0;\n    margin: 0 auto;\n\n    .about-us-wrap {  \n      .about-us-box {\n        .about-us-container {\n          flex-direction: column;\n          gap: 1rem;\n  \n          .text-box {\n            .text-box-inner {\n              .list-text-box {\n                --list-text-grid-number: 1;\n                --list-text-grid-row-gap: 0.5rem;\n                --list-text-grid-column-gap: 0.75rem;\n                \n                .list-text {\n                  --list-text-font-size: 0.875rem;\n                  --list-text-margin-left: 1.25rem;\n                }\n              }\n            }        \n          }\n  \n          .img-box {\n            max-width: 9rem;\n          }\n        }\n      }\n    }  \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
